module.exports = __webpack_public_path__ + "img/chat-settings.70d20844.png";